/* Kick Frame — Nederlandse teksten voor alles wat de scripts zelf in beeld zetten
   (winkelwagen-lade, meldingen, ticket, levertijd, upsell, "On your wall", 3D, programma).
   Draait alleen als de pagina Nederlands is (<html lang="nl">, dus op kickframe.eu/nl).
   Paginateksten zelf staan in de theme-bestanden (locales in de section-schema's). */
(function () {
  if (!/^nl/i.test(document.documentElement.lang || '')) return;

  // exacte zinnen (zonder spaties aan begin/eind)
  var D = {
    'Add to cart': 'In winkelwagen',
    'Unavailable': 'Niet beschikbaar',
    'Sold out': 'Uitverkocht',
    'Added to your cart': 'Toegevoegd aan je winkelwagen',
    'Could not add to cart. Please try again.': 'Toevoegen is mislukt. Probeer het opnieuw.',
    'Could not remove the item. Please try again.': 'Verwijderen is mislukt. Probeer het opnieuw.',
    'File is too large (max 20MB).': 'Het bestand is te groot (max. 20 MB).',
    'Please upload a photo before ordering.': 'Upload eerst een foto voordat je bestelt.',
    'Uploading photo…': 'Foto uploaden…',
    'Subscribing failed. Please try again.': 'Inschrijven is mislukt. Probeer het opnieuw.',
    'Subscribing failed. Please check your internet connection.': 'Inschrijven is mislukt. Controleer je internetverbinding.',
    "Thanks! You're subscribed.": 'Bedankt! Je bent ingeschreven.',
    'Cart': 'Winkelwagen',
    'Your cart': 'Je winkelwagen',
    'Checkout': 'Afrekenen',
    'Remove': 'Verwijderen',
    'Subtotal': 'Subtotaal',
    'Your cart is empty.': 'Je winkelwagen is leeg.',
    'Choose a poster first': 'Kies eerst een poster',
    'With your own photo': 'Met je eigen foto',
    'Newsletter': 'Nieuwsbrief',
    'Never miss a new design.': 'Mis nooit een nieuw ontwerp.',
    'Leave your email address and be the first to hear about new designs.': 'Laat je e-mailadres achter en hoor als eerste over nieuwe ontwerpen.',
    'Email address': 'E-mailadres',
    'Subscribe': 'Inschrijven',
    'No spam. Unsubscribe with one click.': 'Geen spam. Met één klik uitschrijven.',
    'Close': 'Sluiten',
    'Framed': 'Ingelijst',
    'Unframed': 'Zonder lijst',
    'With hanger': 'Met posterhanger',
    // matchday-ticket in de winkelwagen
    'Your order': 'Je bestelling',
    'Admit one': 'Toegangsbewijs',
    'Free shipping · 2-4 days': 'Gratis verzending · 2-4 dagen',
    // upsell in de winkelwagen
    'Mix any designs. The discount is applied automatically.': 'Combineer elk ontwerp. De korting wordt automatisch verrekend.',
    '+ Add': '+ Toevoegen',
    'Add': 'Toevoegen',
    'Adding…': 'Toevoegen…',
    // "Complete the wall" op de productpagina
    'Complete the wall': 'Maak je muur compleet',
    '2 A3 posters for €44.99': '2 A3-posters voor €44,99',
    '· mix any designs, the discount is applied in your cart': '· combineer elk ontwerp, de korting wordt in je winkelwagen verrekend',
    // wedstrijdprogramma
    'Poster details': 'Posterdetails',
    'Match programme': 'Wedstrijdprogramma',
    'Team sheet': 'Opstelling',
    'Size': 'Formaat',
    'Finish': 'Afwerking',
    'Paper': 'Papier',
    'Print': 'Druk',
    'Kick-off': 'Aftrap',
    'Returns': 'Retour',
    '170 gsm semi-gloss, FSC': '170 grams halfglans, FSC',
    'Printed locally, close to you': 'Lokaal gedrukt, dicht bij jou',
    'Free delivery in 2–4 days': 'Gratis bezorgd in 2–4 dagen',
    '14 days after receipt': '14 dagen na ontvangst',
    'Football posters': 'Voetbalposters',
    // levertijd boven de knop
    'Order today,': 'Vandaag besteld,',
    'Free shipping · estimated, 2–4 business days': 'Gratis verzending · verwacht, 2–4 werkdagen',
    // "On your wall" en 3D
    'On your wall': 'Aan je muur',
    'Not sure which size? See it on a wall': 'Twijfel je over het formaat? Bekijk het aan de muur',
    'See this poster on a wall, at real size': 'Bekijk deze poster op ware grootte aan de muur',
    'Poster on a wall, at real size': 'Poster op ware grootte aan de muur',
    'Poster on a living room wall': 'Poster aan een woonkamermuur',
    'Sofa 200 cm': 'Bank 200 cm',
    'View in 3D': 'Bekijk in 3D',
    'View this poster in 3D': 'Bekijk deze poster in 3D',
    'Poster in 3D': 'Poster in 3D',
    'Drag to rotate': 'Sleep om te draaien',
    'you@email.com': 'jij@email.nl'
  };

  var DAYS = { Mon: 'ma', Tue: 'di', Wed: 'wo', Thu: 'do', Fri: 'vr', Sat: 'za', Sun: 'zo' };
  var MONTHS = { Jan: 'jan', Feb: 'feb', Mar: 'mrt', Apr: 'apr', May: 'mei', Jun: 'jun', Jul: 'jul', Aug: 'aug', Sep: 'sep', Oct: 'okt', Nov: 'nov', Dec: 'dec' };
  function date(s) {
    return s.replace(/\b(Mon|Tue|Wed|Thu|Fri|Sat|Sun)\b/g, function (m) { return DAYS[m]; })
      .replace(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/g, function (m) { return MONTHS[m]; });
  }
  var FINISH = { 'unframed': 'zonder lijst', 'in a black wooden frame': 'in een zwarte houten lijst', 'with a black wooden hanger': 'met een zwarte houten posterhanger' };

  // zinnen met een bedrag, datum of aantal erin
  var R = [
    [/^(.+) selected\. Your photo will be sent along when you add it to your cart\.$/, '$1 gekozen. Je foto wordt meegestuurd als je hem in je winkelwagen legt.'],
    // regel in de winkelwagen-lade, bv. "A3 · Unframed · 1x"
    [/^(.*· )(Unframed|Framed|With hanger)( · \d+x)$/, function (m, a, f, b) { return a + D[f] + b; }],
    [/^delivered (.+)$/, function (m, d) { return 'in huis ' + date(d); }],
    [/^from (€.+)$/, 'vanaf $1'],
    [/^Add a second A3 – pay (€[\d.,]+) for both$/, 'Voeg een tweede A3 toe – betaal $1 voor beide'],
    [/^✓ 2 A3 posters for (€[\d.,]+)$/, '✓ 2 A3-posters voor $1'],
    [/^2 A3 posters for €([\d]+)[.,](\d\d)$/, '2 A3-posters voor €$1,$2'],
    [/^Deal applied: you save (.+)$/, 'Deal toegepast: je bespaart $1'],
    [/^(unframed|in a black wooden frame|with a black wooden hanger) · shown at real size above a 200 cm sofa$/, function (m, f) { return FINISH[f] + ' · op ware grootte boven een bank van 200 cm'; }]
  ];

  function tr(s) {
    var t = s.trim();
    if (!t || t.length > 200) return null;
    var r = D[t];
    if (r === undefined) {
      for (var i = 0; i < R.length; i++) {
        if (R[i][0].test(t)) { r = t.replace(R[i][0], R[i][1]); break; }
      }
    }
    if (r === undefined || r === t) return null;
    return s.replace(t, r);
  }

  var ATTRS = ['placeholder', 'aria-label', 'title'];
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };
  function walk(node) {
    if (node.nodeType === 3) {
      var n = tr(node.nodeValue);
      if (n !== null) node.nodeValue = n;
      return;
    }
    if (node.nodeType !== 1 || SKIP[node.nodeName]) return;
    for (var a = 0; a < ATTRS.length; a++) {
      var v = node.getAttribute(ATTRS[a]);
      if (v) { var nv = tr(v); if (nv !== null) node.setAttribute(ATTRS[a], nv); }
    }
    for (var c = node.firstChild; c; c = c.nextSibling) walk(c);
  }

  function start() {
    walk(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') walk(m.target);
        else if (m.type === 'attributes') walk(m.target);
        else m.addedNodes.forEach(walk);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
